var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrocopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "var(--icon-color)",
    viewBox: "0 0 300 300",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 30.310819,
    y1: -32.491454,
    x2: -30.310819,
    y2: 32.491454,
    transform: "translate(59.897026 72.6291)",
    fill: "none",
    stroke: "#3f5787",
    strokeWidth: 14
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: -38.070346,
    y1: -75.072343,
    x2: 38.070347,
    y2: 75.072343,
    transform: "translate(67.656554 180.192897)",
    fill: "none",
    stroke: "#3f5787",
    strokeWidth: 14
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: -59.986939,
    y1: 82.570258,
    x2: 59.986939,
    y2: -82.570258,
    transform: "translate(165.71384 172.694982)",
    fill: "none",
    stroke: "#3f5787",
    strokeWidth: 14
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 67.746467,
    y1: 24.640675,
    x2: -67.746467,
    y2: -24.640675,
    transform: "translate(157.954312 64.778321)",
    fill: "none",
    stroke: "#3f5787",
    strokeWidth: 14
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: -29.640606,
    y1: -32.491454,
    x2: 29.640605,
    y2: 32.491454,
    transform: "translate(239.815353 72.6291)",
    fill: "none",
    stroke: "#3f5787",
    strokeWidth: 14
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 37.403621,
    y1: -75.072343,
    x2: -37.403621,
    y2: 75.072343,
    transform: "translate(232.052337 180.192897)",
    fill: "none",
    stroke: "#3f5787",
    strokeWidth: 14
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 59.281211,
    y1: 82.923122,
    x2: -59.281211,
    y2: -82.923122,
    transform: "translate(135.367505 172.342118)",
    fill: "none",
    stroke: "#3f5787",
    strokeWidth: 14
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 67.044227,
    y1: -24.640675,
    x2: -67.044227,
    y2: 24.640675,
    transform: "translate(143.130521 64.778321)",
    fill: "none",
    stroke: "#3f5787",
    strokeWidth: 14
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrocopy);
export default __webpack_public_path__ + "static/media/microcopy.3a57b1724a52bfb1aee297eaed92d51b.svg";
export { ForwardRef as ReactComponent };